import React from 'react'
import {observer} from 'mobx-react'
import {Button, Glyphicon} from 'react-bootstrap'
import SimpleTable from './table'

const SelectionEditor = ({store}) => {
  // const useAllData = (
  //   <Checkbox checked={store.cv.currBatchStore.apply2all} onChange={(a, b) => {
  //     store.cv.currBatchStore.switchApply2all()
  //   }}>
  //     use all dataset (not the selection)
  //   </Checkbox>
  // )
  return (
    <div>
      {
        store.cv.currBatchStore.apply2all ? null : (
          <SimpleTable
            renderers={[
              (row, idx) => (
                <Button bsSize='xs' onClick={() => {
                  store.cv.currBatchStore.removeFromSelection(idx)
                }}>
                  <Glyphicon glyph='remove' />
                </Button>
              ),
              (row, idx) => store.cv.currBatchStore.isConflicting(idx) && (
                <span className='text-danger'>&nbsp; <Glyphicon glyph='remove-sign' /> conflict!</span>
              ),
              (row, idx) => store.cv.currBatchStore.itemTitle(row)
            ]}
            data={store.cv.selectedItems}
          />
        )
      }
    </div>
  )
}
export default observer(SelectionEditor)
